import Link from "next/link";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";
import Picture from "@/components/ui/picture";
import { ImageDTO } from "@/api/generated-api";
import { useProductCheckout } from "../../hooks/useProductCheckout";
import { observer } from "mobx-react-lite";
import AuthModal from "@/views/auth";

interface DetailHeroProps {
  name: string;
  top_banner_image: ImageDTO;
  is_preorder: boolean;
}

const DetailHero = ({ name, top_banner_image, is_preorder }: DetailHeroProps) => {
  const { handleBuyProduct, authModalProps } = useProductCheckout();

  return (
    <section className={S.hero}>
      <div className={S.background}>
        <Picture image={top_banner_image} className={S.backgroundImage} />
      </div>
      <div className={S.overlay} />

      <Container className={S.container}>
        <div className={S.content}>
          <div className={S.titleBlock}>
            <div className={S.breadcrumbs}>
              <Link href="/catalog" className={S.breadcrumbLink}>
                Каталог
              </Link>
              <span className={S.breadcrumbSeparator} aria-hidden="true">
                /
              </span>
              <span className={S.breadcrumbCurrent}>{name}</span>
            </div>
            <h1 className={S.title}>{name}</h1>
          </div>

          <div className={S.actions}>
            <Link href="/configurator" className={S.outlineButton}>
              Индивидуальный запрос
            </Link>
            <button onClick={handleBuyProduct} className={S.solidButton}>
              {is_preorder ? "Предзаказ" : "Купить"}
            </button>
          </div>
        </div>
      </Container>
      <AuthModal {...authModalProps} />
    </section>
  );
};

export default observer(DetailHero);
